module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-lock-2e24b076.svg";